import { component, observable, subscribe } from 'knockout-decorators'
import { marked } from 'marked'

import { pageState } from '~/store/page'
import type { PageAlertConfig } from '@tixa/schema'

import './page-alert.less'
import source from './page-alert.html?raw'

function renderMarkdown(text) {
  const renderer = new marked.Renderer()
  const linkRenderer = renderer.link
  renderer.link = (href, title, textToRender) => {
    const htmlresult = linkRenderer.call(renderer, href, title, textToRender)
    return htmlresult.replace(/^<a /, '<a target="_blank" rel="nofollow" ')
  }
  return marked.parse(text, { renderer })
}

@component('page-alert', source)
export class PageAlert {
  @observable public hideOnSearch = false

  private config = pageState.config

  private isTest = import.meta.env.MODE !== 'production'
  private alert = this.config.alert || null

  constructor(params?: { hideOnSearch?: boolean }) {
    if (params?.hideOnSearch !== undefined) {
      this.hideOnSearch = params.hideOnSearch
    }

    if (params?.hideOnSearch) {
      subscribe(
        () => params.hideOnSearch,
        (newValue) => {
          this.hideOnSearch = newValue || false
        }
      )
    }
  }

  private get alertsAsArray(): PageAlertConfig[] {
    if (this.alert === null) {
      return []
    }
    if (typeof this.alert === 'object' && Array.isArray(this.alert)) {
      return this.alert
    }
    if (typeof this.alert === 'object' && !Array.isArray(this.alert)) {
      return [this.alert]
    }
    if (typeof this.alert === 'string') {
      return [{ type: 'danger', message: this.alert }]
    }
    return []
  }

  private get alerts(): (PageAlertConfig & {
    renderText: string
    renderType: string
  })[] {
    return this.alertsAsArray.map((alert) => {
      return {
        ...alert,
        renderText: renderMarkdown(alert.message),
        renderType: `alert-${alert.type}`,
      }
    })
  }
}
